/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useRef } from 'react'
import { useHistory, Link } from 'react-router-dom'
import { useAuth } from 'src/contexts/auth.context'
import { useSideBarContext } from 'src/contexts/SideBarContext'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'
import { routes } from 'src/navigation/routes'
import { ROLES } from 'src/tools'
import NotificationList from './partials/notification-list'

// eslint-disable-next-line react/prop-types
export const UserLayout = ({ children }) => {
  const history = useHistory()
  const { logout, user } = useAuth()
  const { toggleSidebar } = useSideBarContext()

  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)

  const refSettingsMenu = useRef()
  const refNotificationsMenu = useRef()

  useOnClickOutside(refSettingsMenu, () => setIsSettingsOpen(false))
  useOnClickOutside(refNotificationsMenu, () => setIsNotificationsOpen(false))

  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen)
  }

  const toggleSettings = () => {
    setIsSettingsOpen(!isSettingsOpen)
  }

  const openLink = (link) => (e) => {
    e.preventDefault()
    history.push(link)
    setIsSettingsOpen(false)
  }

  const openLogout = () => {
    logout()
  }

  const two = `${
    user.first_name.length > 0 ? user.first_name[0].toUpperCase() : ''
  }${user.last_name.length > 0 ? user.last_name[0].toUpperCase() : ''}`

  return (
    <div className="contentHb">
      <div className="wrapperHb">
        <div className="headerHb">
          <div className="headerHb-bar" onClick={toggleSidebar}>
            <span />
          </div>

          <div className="headerHb-wrap">
            {user.role_id === ROLES.student ? (
              <>
                <span className="headerHb-name">
                  Math: <span>Level</span>
                  <i>{user.level}</i>
                </span>
                <a href="#" className="headerHb-star">
                  <i className="hb-ico star-ico" />
                  <span>{user.level_name}</span>
                </a>
              </>
            ) : (
              <span className="hello-header">
                Hello,{' '}
                <Link to="/profile">
                  {user.first_name} {user.last_name}
                </Link>
                !
              </span>
            )}
          </div>

          <div className="headerHb-row">
            <ul className="headerHb-list">
              {user.role_id === ROLES.student && (
                <li className="battery-li">
                  <span>{user.percent}%</span>
                  <i className="hb-ico battery-ico" />
                </li>
              )}

              <li>
                <Link
                  to={routes.favorites.index}
                  className={user.favorites_count > 0 ? 'active' : ''}
                >
                  <i className="hb-ico like-ico" />
                </Link>
              </li>

              <li
                className={
                  isNotificationsOpen
                    ? 'headerHb-notificationHb dropHb active'
                    : 'headerHb-notificationHb dropHb'
                }
              >
                <a
                  href="#"
                  className={
                    user.notifications?.length > 0
                      ? 'dropHb-top active'
                      : 'dropHb-top'
                  }
                  onClick={toggleNotifications}
                >
                  <i className="hb-ico bell-ico" />
                </a>

                <div
                  ref={refNotificationsMenu}
                  className="headerHb-drop__info dropHb-info"
                >
                  <NotificationList
                    notifications={user.notifications}
                    total={user.notifications_count}
                    toggleNotifications={toggleNotifications}
                  />
                </div>
              </li>
            </ul>

            <div
              className={
                isSettingsOpen
                  ? 'headerHb-drop dropHb active'
                  : 'headerHb-drop dropHb'
              }
            >
              <div
                className="headerHb-user dropHb-top ava-top"
                onClick={toggleSettings}
              >
                {user.avatar ? (
                  <img
                    src={`${process.env.REACT_APP_S3_HOST}/${user.avatar}`}
                    alt="avatar"
                  />
                ) : (
                  <div>{two}</div>
                )}
              </div>

              <div
                ref={refSettingsMenu}
                className="headerHb-drop__info dropHb-info"
              >
                <ul>
                  <li>
                    <a href="#" onClick={openLink(routes.profile.index)}>
                      {/* <i className="hb-ico menu-1"></i> */}
                      <i className="hb-ico">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2zm0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      Profile
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={openLink(routes.invites.index)}>
                      {/* <i className="hb-ico menu-2"></i> */}
                      <i className="hb-ico">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      Invites
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={openLink(routes.billing.index)}>
                      {/* <i className="hb-ico menu-4"></i> */}
                      <i className="hb-ico">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      Billing
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={openLink(routes.settings.index)}>
                      {/* <i className="hb-ico menu-5"></i> */}
                      <i className="hb-ico">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0 0 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 0 0-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 0 0 .61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74 0-.2.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                            fill="currentColor"
                          />
                        </svg>
                      </i>
                      Settings
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={openLogout}>
                      <i className="hb-ico menu-6" />
                      {/* <i className="hb-ico">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4m7 14l5-5-5-5m5 5H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </i> */}
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {children}
      </div>
    </div>
  )
}
